/* eslint-disable jsx-a11y/anchor-is-valid */
import {listDeviceType} from "../api";
import React, {useEffect, useState} from 'react'
import {ThemeProvider} from "@mui/material";
import {SectionHeader} from "../SectionHeader";
import {DeviceType} from "../models/Models";
import {PageTitle} from "../../../../_metronic/layout/core";
import {EditDeviceType} from "./edit/EditDeviceType";
import {CreateDeviceType} from "./create/CreateDeviceType";
import {DeleteDeviceType} from "./delete/DeleteDeviceType";
import {getColumns, theme} from "./DeviceTypeListDataGridConfig";
import {DataGrid, GridCellParams, GridSelectionModel, ruRU} from "@mui/x-data-grid";
import AlertDismissible from "../../../components/alerts/AlertDismissible";

export function DeviceTypeListPage() {
    const [refresh, setRefresh] = useState(Date.now())
    const [message, setMessage] = useState('')
    const [showEditForm, setShowEditForm] = useState(false)
    const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);
    const [deviceTypeList, setDeviceTypeList] = useState<DeviceType[] | undefined>(undefined)
    const [deviceTypeToEdit, setDeviceTypeToEdit] = useState<DeviceType | undefined>(undefined)

    useEffect(() => {
        const getResponse = async () => {
            const response = await listDeviceType()
            switch (response.status) {
                case "ok":
                    setDeviceTypeList(response.data.data.items as DeviceType[])
                    return true
                default:
                    console.log(response)
                    setMessage("Сервер не смог обработать запрос. Попробуйте обновить страницу.")
                    return false;
            }
        }

        getResponse()
    }, [refresh])

    const editDeviceType = (params: GridCellParams) => {
        // Разрешаем редактирование лишь при клике по наименованию типа устройств
        if (params.field === 'name') {
            setDeviceTypeToEdit(params.row)
            setShowEditForm(true)
        }
    }

    const refreshPage = () => {
        setShowEditForm(false)
        setRefresh(Date.now())
    }

    return (
        <>
            <PageTitle breadcrumbs={[]}>Типы устройств</PageTitle>

            <div className="card">
                <SectionHeader/>

                {message && <AlertDismissible message={message}/>}

                <div className="card-body d-flex justify-content">
                    <div className="w-800px">
                        <ThemeProvider theme={theme}>
                            <DataGrid
                                autoHeight
                                hideFooter
                                checkboxSelection
                                disableColumnMenu
                                disableSelectionOnClick
                                onCellClick={editDeviceType}
                                columns={getColumns()}
                                rows={deviceTypeList || []}
                                localeText={ruRU.components.MuiDataGrid.defaultProps.localeText}
                                selectionModel={selectionModel}
                                onSelectionModelChange={(newSelectionModel) => {
                                    setSelectionModel(newSelectionModel);
                                }}
                            />
                        </ThemeProvider>
                    </div>

                    <div>
                        <CreateDeviceType onFinish={refreshPage}/>
                        {showEditForm &&
                        <EditDeviceType deviceType={deviceTypeToEdit} showEditForm={showEditForm} onClose={() => setShowEditForm(false)} onFinish={refreshPage}/>
                        }
                        {selectionModel.length !== 0 &&
                        <DeleteDeviceType deviceTypeIdList={selectionModel as number[]} onFinish={refreshPage}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
